import { useContent } from "@/context/ContentContext";
import PagePlacements from "@/components/PagePlacements";

// Parsuje tekst polityki: linie "## " to sekcje, pozostałe linie to paragrafy.
function parseCookieBody(body) {
  if (!body) return [];
  const lines = body.split(/\r?\n/);
  const sections = [];
  let cur = null;
  for (const raw of lines) {
    const line = raw.trim();
    if (line.startsWith("## ")) {
      if (cur) sections.push(cur);
      cur = { title: line.slice(3).trim(), paragraphs: [] };
    } else if (line === "") {
      // separator paragrafu
    } else {
      if (!cur) cur = { title: "", paragraphs: [] };
      cur.paragraphs.push(line);
    }
  }
  if (cur) sections.push(cur);
  return sections;
}

export default function CookiePolicy() {
  const { pages } = useContent();
  const cp = pages?.cookie_policy || {};
  const sections = parseCookieBody(cp.body || "");

  return (
    <div data-testid="cookie-policy-page" className="relative max-w-4xl mx-auto px-6 py-20">
      <div className="text-white/70 text-xs uppercase tracking-widest font-semibold">Dokumenty</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-white mt-3">
        {cp.title || "Polityka plików cookie"}
      </h1>
      {cp.subtitle && <p className="text-white/70 mt-3">{cp.subtitle}</p>}

      <div className="rm-card p-8 md:p-10 mt-10 space-y-8 leading-relaxed">
        {sections.length === 0 && (
          <p className="text-slate-500">Polityka cookies jest w przygotowaniu.</p>
        )}
        {sections.map((s, i) => (
          <section key={i} data-testid={`cookie-section-${i}`}>
            {s.title && (
              <h2 className="font-display text-xl font-bold text-[#1f3a8a] mb-3">{s.title}</h2>
            )}
            <div className="text-slate-700 text-sm space-y-2">
              {s.paragraphs.map((p, pi) => (
                <p key={pi}>{p}</p>
              ))}
            </div>
          </section>
        ))}

        <section>
          <h2 className="font-display text-xl font-bold text-[#1f3a8a] mb-3">Zmiana ustawień</h2>
          <p className="text-slate-700 text-sm">
            <button
              data-testid="reopen-cookie-banner"
              onClick={() => {
                localStorage.removeItem("rm_cookie_consent");
                window.location.reload();
              }}
              className="text-[#1f3a8a] underline font-semibold"
            >
              Kliknij tutaj, aby ponownie wyświetlić baner cookies
            </button>{" "}
            i zmienić swoje preferencje.
          </p>
        </section>
      </div>
      <PagePlacements page="polityka-cookies" />
    </div>
  );
}
